import { call, put, takeEvery } from "redux-saga/effects";
import { deleteAccountRequest, deleteAccountSuccess, deleteAccountFailure } from "../slice/deleteAccountSlice";
import { deleteAccount as deleteAccountApi } from "@src/api/apiService"; // Implement this API function

export function* deleteAccount(): Generator<any, void, any> {
    try {
        yield call(deleteAccountApi);
        yield put(deleteAccountSuccess());
    } catch (error: any) {
        yield put(deleteAccountFailure(error?.response?.data?.detail || error.message || "Unknown error"));
    }
}

export function* deleteAccountSaga() {
    yield takeEvery(deleteAccountRequest.type, deleteAccount);
}
